import { render, staticRenderFns } from "./DialogMove.vue?vue&type=template&id=6144c87d&scoped=true&"
import script from "./DialogMove.vue?vue&type=script&lang=js&"
export * from "./DialogMove.vue?vue&type=script&lang=js&"
import style0 from "./DialogMove.vue?vue&type=style&index=0&id=6144c87d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144c87d",
  null
  
)

export default component.exports